module.exports = __webpack_public_path__ + "static/media/rotate-360.09e0a7bc.svg";